import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

export const Route = createFileRoute("/_authenticated/_care/therapy-caseload")({
  beforeLoad: ({ context }) => guardRoute(context.me, "therapy-caseload"),
  component: Outlet,
});
